module.exports = __webpack_public_path__ + "static/img/brees-2018-top.e833d7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-top.jpg
// module id = YVL2
// module chunks = 1